document.addEventListener('DOMContentLoaded', () => {
	const injectShippedFooterCSS = () => {
		if (document.getElementById('shipped-footer-ada-css')) return;
		const style = document.createElement('style');
		style.id = 'shipped-footer-ada-css';
		style.innerHTML = `
            ul.shipped-footer-links {
                list-style: none !important;
                padding: 0 !important;
                margin: 10px 20px 0 10px !important;
                display: flex !important;
                align-items: center !important;
                flex-wrap: wrap !important;
                justify-content: center !important;
            }
            ul.shipped-footer-links li {
                line-height: 1 !important; 
            }
            ul.shipped-footer-links li:not(:last-child) {
                border-right: 1px solid currentColor !important;
                padding-right: 8px !important;
                margin-right: 8px !important;
            }
        `;
		document.head.appendChild(style);
	};
	injectShippedFooterCSS();

	const catchInjectedModal = (selector, callback) => {
		const intervalTime = 50;
		const maxTime = 2500;
		let timePassed = 0;

		const timer = setInterval(() => {
			const element = document.querySelector(selector);
			if (element) {
				clearInterval(timer);
				callback(element);
			}

			timePassed += intervalTime;
			if (timePassed >= maxTime) {
				clearInterval(timer);
			}
		}, intervalTime);
	};

	document.addEventListener('click', (event) => {
		const triggerBtn = event.target.closest('.shipped-learn-more, #cart-notification > div.dynamic-shipped-widget > div > a');

		if (triggerBtn) {
			catchInjectedModal('.shipped-modal-overlay', (modal) => {
				fixShippedModalADA(modal, triggerBtn);
			});
		}
	});

	const cartWrapper = document.querySelector('cart-notification');
	if (cartWrapper) {
		const buttonObserver = new MutationObserver(() => {
			const addButton = document.querySelector('.shipped-toggle.opt-in');
			const learnMoreBtn = document.querySelector('.shipped-learn-more');

			if (addButton && !addButton.hasAttribute('role')) {
				addButton.setAttribute('role', 'button');
				addButton.setAttribute('aria-label', 'Add Shipped Shield package assurance to cart');
			}
			if (learnMoreBtn && !learnMoreBtn.hasAttribute('role')) {
				learnMoreBtn.setAttribute('role', 'button');
				learnMoreBtn.setAttribute('aria-label', 'Learn more about Shipped Shield package assurance');
			}
		});

		buttonObserver.observe(cartWrapper, { childList: true, subtree: true });
	}
});

const fixShippedModalADA = (modalElement, triggerButton) => {
	setTimeout(() => {
		const dialog = document.querySelector('.shipped-dialog');
		const gotItButton = document.querySelector('.shipped-got-it');
		const title = document.querySelector('.shipped-dialog-title');

		if (!dialog || !gotItButton || !title) return;

		gotItButton.setAttribute('role', 'button');
		gotItButton.setAttribute('tabindex', '0');
		dialog.setAttribute('role', 'dialog');
		dialog.setAttribute('aria-modal', 'true');
		dialog.setAttribute('aria-labelledby', 'shippedDialogHeading');
		title.setAttribute('id', 'shippedDialogHeading');
		dialog.setAttribute('tabindex', '-1');

		dialog.focus();

		dialog.addEventListener('keydown', function (event) {
			const focusableElements = dialog.querySelectorAll('a[href], [tabindex="0"]');
			if (focusableElements.length === 0) return;

			const firstElement = focusableElements[0];
			const lastElement = focusableElements[focusableElements.length - 1];

			if (event.key === 'Tab') {
				if (event.shiftKey) {
					if (document.activeElement === firstElement || document.activeElement === dialog) {
						event.preventDefault();
						lastElement.focus();
					}
				} else {
					if (document.activeElement === lastElement) {
						event.preventDefault();
						firstElement.focus();
					}
				}
			}
			if (event.key === 'Escape') {
				gotItButton.click();
				if (triggerButton) triggerButton.focus();
			}
		});

		gotItButton.addEventListener('keydown', function (event) {
			if (event.key === 'Enter') {
				gotItButton.click();
				if (triggerButton) triggerButton.focus();
			}
		});

		gotItButton.addEventListener('click', function () {
			setTimeout(() => {
				if (triggerButton) triggerButton.focus();
			}, 50);
		});

		// Lists & Footer Formatting
		const listContainer = modalElement.querySelector('.shipped-dialog-list');
		if (listContainer && !listContainer.hasAttribute('role')) {
			listContainer.setAttribute('role', 'list');
		}

		const listItems = modalElement.querySelectorAll('.shipping-dialog-list-item');
		listItems.forEach((item) => {
			if (!item.hasAttribute('role')) {
				item.setAttribute('role', 'listitem');
			}
		});

		const footerLinksContainer = modalElement.querySelector('div.shipped-footer-links');
		if (footerLinksContainer) {
			const ul = document.createElement('ul');
			ul.className = 'shipped-footer-links';
			const links = footerLinksContainer.querySelectorAll('a');

			links.forEach((link) => {
				const li = document.createElement('li');
				li.appendChild(link);
				ul.appendChild(li);
			});
			footerLinksContainer.parentNode.replaceChild(ul, footerLinksContainer);
		}
	}, 100);
};
